module.exports = __webpack_public_path__ + "img/ic_camera.46adf787.png";